module.exports = __webpack_public_path__ + "img/AzEvIrodaja_logo_black_hatszog.e7c27e7a.png";